import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class TagNcaseManagementService {

  constructor(private http: HttpClient) {
  }

  getAllTagsData() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Tag/getAllTagsData');
  }

  deleteTag(tagId: string,type:number) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Tag/deleteTag', { id: tagId , type:type});
  }

  insertReportTag(tagId: string, tagValue: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Tag/insertReportTag', { id: tagId, value: tagValue });
  }


  changeTag(tagId: string, tagValue: string,type:number) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Tag/changeTag', { id: tagId, value: tagValue, type:type });
  }

  enableReportTag(tagId: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Tag/EnableReportTag', { id: tagId });
  }

  getStates(){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/CountryAndState/getStates');
  }

  changeState(tagId: string, tagValue: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/CountryAndState/updateStateName', { id: tagId, newName: tagValue });
  }

  insertTag(tagName: string, tag: string, type: number) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Tag/insertTag', { tag: tag, tagName: tagName, type: type });
  }

  insertState(stateName){
    return this.http.post(globalAdd.Paneladdress + 'api/HA/CountryAndState/insertState', { state: stateName });
  }



  deleteState(tagId: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/CountryAndState/deleteState', { id: tagId });
  }

  getDoctors() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Template/getDoctors');
  }

  getTemplates(eaLogId: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Template/getTemplates?eaLoginId='+ eaLogId );
  }

  getEaUsersWithTemplates(id: string, serverPath: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Template/getEaUsersWithTemplates?eaId='+ id+'&path='+ serverPath );
  }

  shareTemplate(eaId, templateId,templateName) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Template/shareTemplate', { tempId: templateId, eaId: eaId ,templateName:templateName });
  }

}
